import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BlockUIModule } from 'ng-block-ui';
import { FileUploadModule } from 'ng2-file-upload';
import { ConfirmComponent } from './confirm/confirm.component';
import { DirtyTrackingDirective } from './dirty-tracking/dirty-tracking.directive';
import { FocusMeDirective } from './focus-me/focus-me.directive';
import { LazyLoadDirective } from './lazy-load/lazy-load.directive';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { LocalDatePipe, LocalDateTimePipe, LocalPrettyDatePipe, LocalPrettyDatePipeTime, LocalPrettyTimePipe, ObjectFilterPipe, OrdinalPipe, SearchFilterPipe } from './pipes.model';
import { RouterExtService } from './services/router-ext.service';
import { MustEqualDirective, MustMatchDirective } from './validators.model';
import { TableSorting } from '../core/tableSorting.component';
import { UserPropertiesComponent } from './user-properties/user-properties.component';
import { YesNoCancelComponentComponent } from './yes-no-cancel-component/yes-no-cancel-component.component';
import { CopyClipboardDirective } from './clipboard/copy-clipboard.directive';
import { InformComponent } from './inform/inform.component';


@NgModule({
    declarations: [
        MustMatchDirective,
        ConfirmComponent,
        MyProfileComponent,
        DirtyTrackingDirective,
        MustEqualDirective,
        LocalDatePipe,
        LocalDateTimePipe,
        LocalPrettyDatePipe,
        LocalPrettyTimePipe,
        LocalPrettyDatePipeTime,
        OrdinalPipe,
        SearchFilterPipe,
        ObjectFilterPipe,
        LazyLoadDirective,
        FocusMeDirective,
        TableSorting,
        UserPropertiesComponent,
        YesNoCancelComponentComponent,
        CopyClipboardDirective,
        InformComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        FileUploadModule,
    ],
    exports: [
        LocalDatePipe,
        LocalDateTimePipe,
        LocalPrettyDatePipe,
        LocalPrettyTimePipe,
        LocalPrettyDatePipeTime,
        OrdinalPipe,
        SearchFilterPipe,
        ObjectFilterPipe,
        MustMatchDirective,
        ConfirmComponent,
        MyProfileComponent,
        DirtyTrackingDirective,
        MustEqualDirective,
        LazyLoadDirective,
        FocusMeDirective,
        TableSorting,
        UserPropertiesComponent,
        CopyClipboardDirective,
    ],
    providers: [
        RouterExtService
    ]
})
export class CoreModule { }
